import { Component, Inject, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ManuManagement } from '../../models/manu-management/manu-management-model';
import { ManuManagementService } from '../../services/manu-mangement/manu-management.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-manu-management-list',
    templateUrl: './manu-management-list.component.html',
    styleUrls: ['./manu-management-list.component.css']
})
/** manu-management-list component*/
export class ManuManagementListComponent {
    /** manu-management-list ctor */
  public manuList: ManuManagement[];
  searchKeyword: string;
  isActive: string;
  manuType: string;
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  constructor(private readonly manuMangementService: ManuManagementService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("menumanagement").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.getAllManues();
          this.GetRowsPerPageList();
          this.toastr.setRootViewContainerRef(vcr);
          this.isActive = "";
            this.manuType = "";
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  getAllManues() {
    this.manuMangementService.getManues().subscribe(
      data => {
        this.manuList = data;
        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  deleteManu(id) {
    if (confirm("Are you sure to delete this Menu?")) {
      this.manuMangementService.deleteManu(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('Menu has been Deleted.', 'Success');
            setTimeout(() => {
              this.getAllManues();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Oop!', 'Error');
          }
        }
      )
    }
  }
  OnFilterChange() {
    this.filteredItems = this.manuList;

    if (this.searchKeyword != "" && this.searchKeyword != null) {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.filteredItems, this.searchKeyword);
    }
    if (this.isActive == "true") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == true);

    }
    else if (this.isActive == "false") {
      this.filteredItems = this.filteredItems.filter(s => s.isActive == false);
    }
    if (this.manuType !="") {
      this.filteredItems = this.filteredItems.filter(s => s.manuType == this.manuType);

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/manu-management-component/manu-management-list/manu-management-list.component.ts